// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let afflictionTestMethodEnum = {
    'SugarShake': 0,
    'AlcoholWash': 1,
    'DroneUncapping': 2
};

export default afflictionTestMethodEnum;
